import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import * as Styled from './OboBanner.style';

const OboBanner = () => {
  const { obo } = useAuthentication();

  return (
    <Styled.Root>
      <Styled.Label>{`On behalf of ${obo}`}</Styled.Label>
    </Styled.Root>
  );
};

export default OboBanner;
